import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  ViewChild,
  EventEmitter,
} from '@angular/core';

import { ACHPayment } from '../../../models/invoice/ach-payment.model';
import {
  CustomerAddress,
  ManualInvoicePartialPaySetting,
} from '../../../models/invoice/invoice.model';
import { AlertService } from '../../../../core/alert.service';
import { ACHPaymentService } from '../../../services/achpayment.service';
import {
  AccountType,
  CheckType,
  SourceComponent,
} from '../../../models/invoice/payment.model';
import { Settings } from 'src/app/settings/models/settings.model';
import { ACH } from 'src/app/shared/models/invoice/ach.model';
import { Subscription } from 'rxjs';
import { CustomerManagementService } from 'src/app/shared/services/customer.service';

@Component({
  selector: 'app-ach-pay',
  templateUrl: './ach-pay.component.html',
  styleUrls: ['./ach-pay.component.scss'],
})
export class ACHPayComponent implements OnInit, OnDestroy {
  private getCustomerACHSubscription$: Subscription;
  @ViewChild('achPayForm', { static: false }) achForm: HTMLFormElement;

  @Input() isProcessing: boolean = false;
  @Input() isSubmitted: boolean = false;
  @Input() invoiceBalance: any = 0;
  @Input() invoice: any;

  @Input() invoiceNumber: string = '';
  @Input() customerId: number = 0;
  @Input() addressId: number;
  @Input() merchantName: string = ''; //
  @Input() contactNumber: string = ''; //
  @Input() locationData: any;
  @Input() isWorkOrder: boolean;
  @Input() isPartialPayment: boolean = false;
  @Input() userId: string = '';
  @Input() isMultipleInvoices: boolean = false;
  @Input() manualInvoices: any[];
  @Input() tipAmount: number = 0;
  @Input() isSalesInvoice: boolean = false;

  @Input() businessInfo: Settings;
  @Input() customerAddresses: any;
  @Input() customerBusinessContact: any;

  @Output() onValueChange: EventEmitter<any> = new EventEmitter();
  @Output() onAddressAdd: EventEmitter<void> = new EventEmitter();
  @Output() onACHSelect: EventEmitter<ACH> = new EventEmitter();
  @Output() onACHAdd: EventEmitter<boolean> = new EventEmitter();

  selectedAccountType: AccountType = AccountType.CHECKING;
  accountTypes: any = [
    { name: 'Checking', value: AccountType.CHECKING },
    { name: 'Savings', value: AccountType.SAVINGS },
  ];

  selectedCheckType: CheckType | string = '';
  checkTypes: any = [
    { name: 'Select Check Type', value: '' },
    { name: 'Personal', value: CheckType.PERSONAL },
    { name: 'Business', value: CheckType.BUSINESS },
    { name: 'Payroll', value: CheckType.PAYROLL },
  ];

  achPayment: ACHPayment = new ACHPayment();
  agreedToTerms: boolean = false;
  customerAddress: CustomerAddress = new CustomerAddress();
  multipleInvoices: string[];
  manualInvoice: any;
  partialPaymentSetting: ManualInvoicePartialPaySetting =
    new ManualInvoicePartialPaySetting();
  selectedInvoiceString: string = '';
  customerACHDetails: ACH[];
  selectedACH: ACH;
  isAddACH: boolean = false;
  isInitializing: boolean = false;

  constructor(
    private alert: AlertService,
    private achPaymentService: ACHPaymentService,
    private customerService: CustomerManagementService
  ) {}

  ngOnInit() {
    this.getDefaultCustomerAddress();

    if (this.isMultipleInvoices) {
      this.invoiceBalance = 0;

      this.manualInvoices.forEach((invoice) => {
        this.multipleInvoices.push(invoice.InvoiceNumber);

        if (this.isPartialPayment) {
          this.invoiceBalance += invoice.ManualInvoice.requiredPartialPayment;
        } else {
          this.invoiceBalance +=
            invoice.ManualInvoice.status === 'Partial'
              ? invoice.ManualInvoice.balance - invoice.ManualInvoice.totalPaid
              : invoice.ManualInvoice.balance;
        }
      });
    }

    this.loadACHDetails();
  }

  ngOnDestroy(): void {
    this.getCustomerACHSubscription$.unsubscribe();
  }

  getDefaultCustomerAddress(): void {
    if (this.customerAddresses) {
      const address = this.customerAddresses.find((e) => {
        if (this.addressId) {
          return e.Id === this.addressId;
        }

        return e.IsDefault;
      });

      if (address) {
        this.addressId = address.Id;
      }
    }
  }

  getFullAddress(address: any): string {
    return `${address.StreetAddress || ''} ${address.City || ''} ${
      address.CountryCode || ''
    } ${address.ZipCode || ''}`;
  }

  onAddressSelected(id: number): void {
    const address = this.customerAddresses.find((e) => {
      return e.Id === id;
    });

    if (address) {
      this.addressId = address.Id;
      this.onValueChange.emit(this.achForm.form);
    }
  }

  onAccountTypeChanged(type: AccountType): void {
    this.selectedAccountType = type;
    this.achPayment.AccountType = this.selectedAccountType;
    this.onValueChange.emit(this.achForm.form);
  }

  onCheckTypeChanged(type: CheckType | string): void {
    this.selectedCheckType = type;

    if (this.selectedCheckType !== '') {
      this.achPayment.CheckType = this.selectedCheckType as CheckType;
      this.onValueChange.emit(this.achForm.form);
    }
  }

  onChange(key: string, data: string): void {
    this.achPayment[key] = data;
    this.onValueChange.emit(this.achForm.form);
  }

  processPayment(isValid: boolean) {
    // this.isSubmitted = true;
    // if (isValid) {
    //   this.isProcessing = true;
    //   if (!this.agreedToTerms) {
    //     this.alert.alertError({ title: 'Failed', text: 'Please agree to Terms and Conditions' });
    //     this.isProcessing = false;
    //     return;
    //   }
    //   this.achPayment.Amount = this.invoiceBalance;
    //   this.achPayment.InvoiceNumber = this.invoice.invoiceNumber;
    //   this.achPayment.TerminalId = "MAIN";
    //   this.achPayment.IsPartialPayment = this.isPartialPayment;
    //   this.achPayment.Currency = "USD";
    //   this.achPayment.MID = this.locationData.MID;
    //   this.achPayment.SecretApiKey = this.locationData.Secret_API_Key;
    //   this.achPayment.LocationId = this.locationData.Id;
    //   this.achPayment.CustomerId = this.invoice.customerId.toString();
    //   this.achPayment.StreetAddress1 = this.customerAddress.StreetAddress1;
    //   this.achPayment.City = this.customerAddress.City;
    //   this.achPayment.State = this.customerAddress.State;
    //   this.achPayment.PostalCode = this.customerAddress.PostalCode;
    //   this.achPayment.SourceComponent = this.isWorkOrder
    //     ? SourceComponent.WorkOrder
    //     : SourceComponent.ManualInvoice;
    //   this.achPaymentService.achCharge(this.achPayment)
    //     .pipe(takeUntil(this.unsubscribe$))
    //     .subscribe((res: any) => {
    //       if (res) {
    //         this.isProcessing = false;
    //         this.isSubmitted = false;
    //         this.close(true);
    //       }
    //     }, () => {
    //       this.isProcessing = false;
    //       this.isSubmitted = false;
    //       this.alert.alertError(`Payment failed for invoice number: ${this.achPayment.InvoiceNumber}`);
    //     });
    // }
  }

  processMultiplePayments() {
    if (!this.agreedToTerms) {
      this.alert.alertError({ text: 'Please Agree to Terms and Conditions.' });
      return false;
    }

    // this.isProcessingPayment = true;
    let promises = [];

    for (var i = 0; i < this.manualInvoices.length; i++) {
      this.achPayment.Amount = this.isPartialPayment
        ? this.manualInvoices[i].ManualInvoice.requiredPartialPayment
        : this.manualInvoices[i].ManualInvoice.balance -
          this.manualInvoices[i].ManualInvoice.totalPaid;
      this.achPayment.InvoiceNumber =
        this.manualInvoices[i].ManualInvoice.invoiceNumber;
      this.achPayment.TerminalId = 'MAIN';
      this.achPayment.IsPartialPayment = this.isPartialPayment;
      this.achPayment.Currency = 'USD';
      this.achPayment.LocationId = this.manualInvoices[i].locationData.Id;

      this.achPayment.CustomerId = this.customerId.toString();
      this.achPayment.StreetAddress1 = this.customerAddress.StreetAddress1;
      this.achPayment.City = this.customerAddress.City;
      this.achPayment.State = this.customerAddress.State;
      this.achPayment.PostalCode = this.customerAddress.PostalCode;
      this.achPayment.SourceComponent =
        this.isWorkOrder == true
          ? SourceComponent.WorkOrder
          : SourceComponent.ManualInvoice;
      this.achPayment.TransactionSource =
        this.isWorkOrder == true
          ? SourceComponent.WorkOrder
          : SourceComponent.ManualInvoice;

      promises.push(
        new Promise((resolve, reject) => {
          this.achPaymentService.achCharge(this.achPayment).subscribe(
            (res: any) => {
              if (res) {
                resolve(res);
                //this.alert.alertSuccess({ title: 'Success', text: 'Successfully charged ACH account!' });
              }
            },
            (err) => {
              reject(
                `Payment failed for invoice number: ${this.achPayment.InvoiceNumber}`
              );
            }
          );
        })
      );
    }

    Promise.all(promises).then((values) => {
      for (var i = 0; i < this.manualInvoices.length; i++) {
        this.manualInvoices[i].paymentResult = values[i];
      }
      // this.close(this.manualInvoices);
      this.isProcessing = false;
    });
  }

  onSelectACH(paymentIdentifier: string): void {
    const ach = this.customerACHDetails.find((e) => e.paymentIdentifier === paymentIdentifier);

    if (ach) {
      this.selectedACH = ach;
      this.onACHSelect.emit(this.selectedACH);
    }
  }

  loadACHDetails(): void {
    this.isInitializing = true;
    this.getCustomerACHSubscription$ =
      this.customerService.getCustomerACHsById(this.customerId)
        .subscribe({
          next: (result: any) => {
            if(result) {
              this.customerACHDetails = result;
              this.getDefaultACH();
            }
            this.isInitializing = false;

          },
          error: () => {
            this.isInitializing = false;
          }
        })
  }

  getDefaultACH(): void {
    if (this.customerACHDetails.length && !this.selectedACH) {
      const card = this.customerACHDetails.find((e) => e.isDefault);
      this.onSelectACH(card?.paymentIdentifier || this.customerACHDetails[0].paymentIdentifier);
    }
  }

  onAddACH(): void {
    this.isAddACH = !this.isAddACH;
    this.onACHAdd.emit(this.isAddACH);
  }
}
